module.exports = __webpack_public_path__ + "img/image 25@3x.37eecc41.png";